import { useSetAtom } from 'jotai';
import { useCallback } from 'react';

import { useChangeNetSuiteRequest } from '../hooks';
import { netSuiteBillFieldValuesState } from './NetSuiteBillRequestForm.states';
import { NetSuiteBillFields } from './NetSuiteBillRequestForm.types';

export const useNetSuiteBillFields = () => {
    const setFieldValues = useSetAtom(netSuiteBillFieldValuesState);

    const changeNetSuiteRequest = useChangeNetSuiteRequest();

    const updateFieldsBulk = useCallback(
        (data: Partial<NetSuiteBillFields>, shouldDispatchChangeEvent = true) => {
            setFieldValues((current) => {
                if (current !== null) {
                    return {
                        ...current,
                        ...data,
                    };
                }

                return current;
            });

            if (shouldDispatchChangeEvent) {
                changeNetSuiteRequest();
            }
        },
        [changeNetSuiteRequest, setFieldValues]
    );

    const onFieldChange = useCallback(
        <K extends keyof NetSuiteBillFields>(key: K, value: NetSuiteBillFields[K]) => {
            setFieldValues((current) => ({
                ...current,
                [key]: value,
            }));

            changeNetSuiteRequest();
        },
        [changeNetSuiteRequest, setFieldValues]
    );

    return {
        updateFieldsBulk,
        onFieldChange,
    };
};
